import { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ImPropTypes from 'react-immutable-proptypes';
import model from './ObjectModel.module.scss';

const propClass = 'property';

export default class ArrayModel extends Component {
  static propTypes = {
    schema: PropTypes.object.isRequired,
    getComponent: PropTypes.func.isRequired,
    getConfigs: PropTypes.func.isRequired,
    specSelectors: PropTypes.object.isRequired,
    name: PropTypes.string,
    displayName: PropTypes.string,
    required: PropTypes.bool,
    // expandDepth: PropTypes.number,
    specPath: ImPropTypes.list.isRequired,
    depth: PropTypes.number,
    includeReadOnly: PropTypes.bool,
    includeWriteOnly: PropTypes.bool,
  };

  render() {
    let {
      getComponent,
      getConfigs,
      schema,
      depth,
      // expandDepth,
      name,
      displayName,
      specPath,
      schemaType,
    } = this.props;
    let description = schema.get('description');
    let items = schema.get('items');
    let title = schema.get('title') || displayName || name;
    let properties = schema.filter(
      (v, key) => ['type', 'items', 'description', '$$ref'].indexOf(key) === -1
    );

    const Markdown = getComponent('Markdown', true);
    const ModelCollapse = getComponent('ModelCollapse');
    const Model = getComponent('Model');
    const Property = getComponent('Property');

    const titleEl = title && (
      <span className="model-title">
        <span className="model-title__text">{title}</span>
      </span>
    );

    /*
    Note: we set `name={null}` in <Model> below because we don't want
    the name of the current Model passed (and displayed) as the name of the array element Model
    */

    return (
      <span className="model">
        <ModelCollapse
          title={titleEl}
          // expanded={depth <= expandDepth}
          expanded={true}
          collapsedContent="[...]"
        >
          <div className="array-model">
            <span
              className={cn(model.model__brace, {
                [model.model__brace__mini]: schemaType === 'mini',
              })}
            >
              [
            </span>
            <div className="array-model-body">
              {properties.size
                ? properties
                    .entrySeq()
                    .map(([key, v]) => (
                      <Property key={`${key}-${v}`} propKey={key} propVal={v} propClass={propClass} />
                    ))
                : null}
              {!description ? (
                properties.size ? (
                  <div className="markdown"></div>
                ) : null
              ) : (
                <Markdown
                  className={cn(model.model__desc, {
                    [model.model__desc__mini]: schemaType === 'mini',
                  })}
                  source={description}
                />
              )}
              <span>
                <Model
                  {...this.props}
                  getConfigs={getConfigs}
                  specPath={specPath.push('items')}
                  name={null}
                  schema={items}
                  required={false}
                  depth={depth + 1}
                />
              </span>
            </div>
            <span
              className={cn(model.model__brace, {
                [model.model__brace__mini]: schemaType === 'mini',
              })}
            >
              ]
            </span>
          </div>
        </ModelCollapse>
      </span>
    );
  }
}
